import {
  defaultValue,
  QualificationState,
  QualificationAction,
  QualificationActionTypes as ActionTypes } from './types';


const initialSpecQCAState: QualificationState = {
  refresh: {},
  isLoading: false,
  isHistoryLoading: false,
  isDetailLoading: false,
  isSubmitting: false,
  isNavigating: false,
  isNavigatingTo: null,
  qualifications: [],
  qualificationDetail: defaultValue,
  definitions: [],
  affiliationTypes: [],
  workTypes: [],
  histories: [],
  specialDefinitions: [],
  specialReferences: []
};


const qualificationReducer = (
  state: QualificationState = initialSpecQCAState,
  action: QualificationAction): QualificationState => {

  switch (action.type) {
    case ActionTypes.INIT:
      return initialSpecQCAState;
    case ActionTypes.REFRESH:
      return { ...state, refresh:{} };
    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.DETAILLOADING:
      return { ...state, isDetailLoading: action.payload };
    case ActionTypes.HISTORYLOADING:
      return { ...state, isHistoryLoading: action.payload };
    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };
    case ActionTypes.SET_SELECT_QUALIFICATION_DETAIL:
      return { ...state, qualificationDetail: action.payload };
    case ActionTypes.SET_SELECT_QUALIFICATIONS:
      return { ...state, qualifications: action.payload };
    case ActionTypes.SET_SELECT_MST_NATIONAL_QUALIFICATIONS:
      return { ...state, definitions: action.payload };
    case ActionTypes.SET_SELECT_QUALIFICATION_HISTORY:
      return { ...state, histories: action.payload }
    case ActionTypes.SET_SELECT_SPECIAL_DEFINITIONS_LIST:
      return { ...state, specialDefinitions: action.payload };
    case ActionTypes.SET_SELECT_SPECIAL_QUALIFICATION_USED_INPROPERTY:
      return { ...state, specialReferences: action.payload };
    case ActionTypes.SET_SELECT_MST_AFFILIATION_TYPES:
      return { ...state, affiliationTypes: action.payload };
    case ActionTypes.SET_SELECT_MST_WORK_TYPES:
      return { ...state, workTypes: action.payload };
  }
  return state;
}

export default qualificationReducer;